import React from 'react'
import usePrompts from 'tennders-transactions/hooks/usePrompts'
import PlateNumbers from 'tennders-transactions/modal/PlateNumbers'
import PromptMessage from 'tennders-market/common/components/prompt/PromptMessage'

const Prompts = () => {
  const { prompts } = usePrompts()

  return (
    <>
      <PlateNumbers />
      <PromptMessage
        prompt={prompts && prompts[0]}
        isVisible={prompts && prompts.length > 0}
      />
    </>
  )
}

export default Prompts
